export const ColorPalette_Mixed = {
	//Game (hex values)
	Background: 0xb8d8ff,
	BackgroundRaised: 0xe1effe,
	Chain: 0xb91ec1,
	Virus: 0xa94dff,
	VirusTrail: 0xbf00ff,

	//Cell Colors (hex value or array of 2 hex values for gradient)
	ImmuneCellA: 0xf37162,
	ImmuneCellB: 0x6cabf9,
	ImmuneCellC: 0xf37162,
	BloodA: [0xff8c80, 0xfc331d],
	BloodB: 0xcc3333,
	VirusA: 0xbc91ca,
	VirusB: 0x7d5da2,
	VirusOriginal: 0xA94DFF,
	VirusLighter: 0xC680FF,
	VirusDarker: 0x7C00CC,
	VirusMoreSaturated: 0x9D00FF,
	VirusLessSaturated: 0xB26EB3,
	VirusTint: 0xDFB3FF,
	VirusShade: 0x6600A1,
	VirusBlendWithBlue: 0x6F00FF,
	VirusBlendWithRed: 0xFF2EFF,
	VirusComplementary: 0x54FF00,
	VirusAnalogous1: 0xFF4DBF,
	VirusAnalogous2: 0x4D9DFF,

	Bullet: 0x63dd5a,
	Tag: 0xff7a7a,

	//Membrane stuff
	MembraneAlpha: 0.1,
	MembraneColor: 0x5294ff,
	AlternateMembraneColor: 0x429eff,
	AlternateMembraneAlpha: 0.1,

	//Lighting parameters
	AmbientScaler: 0.4,
	DiffuseScaler: 0.75,
	RimScaler: 0.0,
	RimPower: 2.0,
	SpecularScaler: 0.5,
	SpecularPower: 16.0,
	DoFScaler: 1.0,
	BackgroundColorSeperation: 1.0,

	//Particle and overlays
	Electricity: 0xE8FDFF,

	//UI (css color hashes)
	UIBackground: '#e3d9cb',
	UITextAndBorders: '#4a443a', //UIDark
	UIDescriptionText: '#031522', //UIDark
	UIButton: '#daf3f5', //UIBackgroundHover
	UIButtonHover: '#ffffff',//UIBackgroundHover
	UIShadow: '#310209', //UIHighlightShadow
	UIHighlight: '#dc736a',
	UIButtonDisabled: 'dddddd',
	UIUnemphasizedText: '#798e9d',

	UIMarketBackground: '#f6ecdc', //UIBackground
	UIMarketButton: '#ffffff',//UIBackgroundHover
	UIMarketTextAndBorders: '#031522', //UIDark
	UIMarketShadow: '#310209',//UIHighlightShadow

	UIIncomingTab: '#f6604f',
	UIIncomingTabText: '#ffffff',//UIBackgroundHover

	UIStat: "#dd0728",
	UIIncreasedStat: '#07dd60',
	UIDecreasedStat: '#8f07dd',

	UIAntibodyBackground: '#cce5ff',

	UITimer: '#f6604f',
	UICarb: '#ffc038',
	UICarbInner: '#ffd885',
	UICarbSpending: '#39a4e6',
	UICarbSpent: '#d1ddff',
	UICarbShadow: '#310209',//UIHighlightShadow

	UITier1: '#00c213',
	UITier2: "#002ac0",
	UITier3: "#7700c0",
	UITier4: "#e58a00",
	UITier5: "#c70000",
	UITier6: "#C70000",
	UIRewardTier: '#e6d200',
	UITierText: '#ffffff',
};
